import { render, staticRenderFns } from "./MoveSwitch.vue?vue&type=template&id=f706e90e&scoped=true&"
import script from "./MoveSwitch.vue?vue&type=script&lang=js&"
export * from "./MoveSwitch.vue?vue&type=script&lang=js&"
import style0 from "./MoveSwitch.vue?vue&type=style&index=0&id=f706e90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f706e90e",
  null
  
)

export default component.exports